import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Tech intern job",
  "description": "",
  "published": "2018-06-09T00:00:00.000Z",
  "redirect_from": ["/blog/tech-intern-job/swizec/8454"],
  "categories": "Business",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Here's the deal, I'm a solopreneur working nights and weekends on this `}<em parentName="p">{`Turn programmers into engineers`}</em>{` business and I have more ideas than time. So I'm looking for an intern to help me out.`}</p>
    <p>{`Why an intern? Three reasons:`}</p>
    <ol>
      <li parentName="ol">{`I don't think there's enough work for an experienced software engineer`}</li>
      <li parentName="ol">{`I think the tasks wouldn't be challenging enough for an experienced engineer`}</li>
      <li parentName="ol">{`Cost; this is a small bootstrapped business`}</li>
    </ol>
    <h2 {...{
      "id": "what-im-offering"
    }}>{`What I'm offering`}</h2>
    <p>{`I can't promise you piles of money and I can't say you're going to build software used by millions. Such is life :)`}</p>
    <p>{`What I `}<em parentName="p">{`can`}</em>{` offer is a paid learning opportunity.`}</p>
    <p>{`You'll work remotely and part-time to implement various solutions big and small in JavaScript, React, and associated web technologies. We'll start small and go bigger as time goes on.`}</p>
    <p>{`I don't care where in the world you are, as long as your English is good enough that we can understand each other smoothly.`}</p>
    <p>{`When you hit a snag, I'm here to help. If you need to buy a book or a course to learn something, I will buy it for you.`}</p>
    <p>{`Think of this as a way to practice solving real problems. You are encouraged to leverage this experience into finding a real real job.`}</p>
    <h2 {...{
      "id": "your-job"
    }}>{`Your job`}</h2>
    <p>{`Your job will be to implement things I don't have time for, so I can focus on producing content. This will involve:`}</p>
    <ul>
      <li parentName="ul">{`improvements to swizec.com`}</li>
      <li parentName="ul">{`building features for learnwhileyoupoop.com`}</li>
      <li parentName="ul">{`evaluating opensource libraries`}</li>
      <li parentName="ul">{`building example code`}</li>
      <li parentName="ul">{`build and improve landing pages`}</li>
    </ul>
    <p>{`The tech stack is a combination of React and Wordpress. You're encouraged to leverage existing solutions instead of reinventing the wheel.`}</p>
    <h2 {...{
      "id": "how-well-work-together"
    }}>{`How we'll work together`}</h2>
    <p>{`We're going to communicate primarily through Slack. Video calls when necessary.`}</p>
    <p>{`We're going to have daily checkins and generally keep in touch while working together. You are encouraged to reach out to me whenever.`}</p>
    <p>{`You'll be paid via PayPal or TransferWise every month based on an hourly rate we'll figure out together. If neither PayPal nor TransferWise work for you, we can figure something out.`}</p>
    <h2 {...{
      "id": "how-well-find-out-if-were-a-fit"
    }}>{`How we'll find out if we're a fit`}</h2>
    <p>{`For hiring, I'm prioritizing `}<a parentName="p" {...{
        "href": "http://qr.ae/TUphry"
      }}>{`slope instead of y-intercept`}</a>{`. That is to say, I want you to be a fast learner not someone who already knows a lot.`}</p>
    <p>{`You should have basic knowledge of JavaScript, React, HTML, etc. I'll give you the chance to learn the rest.`}</p>
    <p>{`The initial hiring process is going to go like this:`}</p>
    <ul>
      <li parentName="ul">{`you've already reached out to me, probably 👍🏼 (unless you're reading this on my blog)`}</li>
      <li parentName="ul">{`after too long a wait, I replied (sorry 😅)`}</li>
      <li parentName="ul">{`you send me something you've made`}</li>
      <li parentName="ul"><strong parentName="li">{`I teach you something`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`you use the concept to build an example app`}</strong></li>
      <li parentName="ul">{`I'll use what you've built to gauge your slope`}</li>
    </ul>
    <p>{`My hope is that even if we don't end up working together, you will still have learned something useful and built a little something you can add to your portfolio. That way I'm not wasting your time.`}</p>
    <h3 {...{
      "id": "next-step"
    }}>{`Next step`}</h3>
    <p>{`Our next step is a `}<strong parentName="p">{`live webinar on June 13th at 9pm Pacific`}</strong>{` on `}<a parentName="p" {...{
        "href": "https://youtube.com/SwizecTeller"
      }}>{`my YouTube channel`}</a>{`.`}</p>
    <p>{`If you can't make it, don't worry. The video will stay available forever, but I encourage you to come say hi and ask questions. This is your chance to evaluate me as well.`}</p>
    <p>{`We're going to cover an intermediate React concept or two.`}</p>
    <h2 {...{
      "id": "️"
    }}>{`✌️`}</h2>
    <p>{`If all that sounds good, see you at the webinar. Hit reply, send me something you've built (school and book/course projects are perfect), and ask your questions :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      